import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import type MultiChannelLink from "@/interface/MultiChannelLink";
import type BiometricStartInfo from "@/interface/BiometricStartInfo";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

//Biometric Basic Information Submit
export default function biometricBasicInformationSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  multiChannel: Ref<MultiChannelLink>,
  biometricStartInfo: Ref<BiometricStartInfo>,
  newForm: Ref<boolean>,
  page1Overlay: Ref<boolean>,
  biometricVerification: Ref<string>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  if (!ccFormValue.value.webFormRequestId) {
    const requestModel = {
      cardId: prop.cardId != "NA" ? prop.cardId : "",
      type: prop.type ? prop.type : "",
      idNo: ccFormValue.value.basicInformation.idNo,
      oldIc:
        ccFormValue.value.basicInformation.idType == "1"
          ? ""
          : ccFormValue.value.basicInformation.oldIc,
      originalUrl: prop.originalUrl,
      errorMessage: prop.errorMessage,
      tmkCrmRefNo: multiChannel.value.crfn,
      marketingCampaignId: multiChannel.value.mci,
      merchantId: multiChannel.value.mc,
      branch: biometricStartInfo.value.branch,
      applicationChannel: biometricStartInfo.value.applicationChannel,
      recruiterId: biometricStartInfo.value.recruiterId,
      recruiterName: biometricStartInfo.value.recruiterName,
      basicInformation: {
        // title: ccFormValue.value.value.basicInformation.title,
        fullName: ccFormValue.value.basicInformation.name,
        idTypeCode: ccFormValue.value.basicInformation.idType,
        idNo: ccFormValue.value.basicInformation.idNo,
        oldIc:
          ccFormValue.value.basicInformation.idType == "1"
            ? ""
            : ccFormValue.value.basicInformation.oldIc,
        militaryNo:
          ccFormValue.value.basicInformation.idType == "1"
            ? ""
            : ccFormValue.value.basicInformation.militaryNo,
        nationalityCode: ccFormValue.value.basicInformation.nationality,
        dateOfBirth: ccFormValue.value.basicInformation.dob,
        emailAddress: ccFormValue.value.basicInformation.email,
        mobileCountryCode: ccFormValue.value.basicInformation.countryCode,
        mobileNumber: ccFormValue.value.basicInformation.mobileNo,
        homePhoneCountryCode:
          ccFormValue.value.basicInformation.homePhoneNo != ""
            ? ccFormValue.value.basicInformation.homeCountryCode
            : "",
        homePhoneNumber: ccFormValue.value.basicInformation.homePhoneNo,
        grossMonthlySalary: ccFormValue.value.basicInformation.grossSalary,
        netMonthlySalary: ccFormValue.value.basicInformation.netSalary,
        professionCode: ccFormValue.value.basicInformation.profession,
        professionOthers: ccFormValue.value.basicInformation.others,
        anyLoan:
          ccFormValue.value.basicInformation.question1 == "Yes" ? true : false,
        repayment: ccFormValue.value.basicInformation.repayment,
      },
    };
    MasterService.basicInformationSubmit(requestModel).then((res) => {
      if (res.status == 200) {
        newForm.value = false;
        ccFormValue.value.webFormRequestId =
          res.data.responseModel.webFormRequestId;
        ccFormValue.value.token = res.data.responseModel.token;
        ccFormValue.value.refNo = res.data.responseModel.refNo;
        const requestModel2 = {
          webFormRequestId: ccFormValue.value.webFormRequestId,
          cardId: prop.cardId,
          icNumber: ccFormValue.value.basicInformation.idNo,
        };
        MasterService.validate(requestModel2, ccFormValue.value.token)
          .then((res) => {
            if (res.status == 200) {
              ccFormValue.value.refNo =
                res.data.responseModel.cardList[0].refNo;
              ccFormValue.value.dropOffStep =
                res.data.responseModel.cardList[0].dropOffStep;
              biometricVerification.value =
                res.data.responseModel.cardList[0].biometricVerification;
              page1Overlay.value = false;
              jumpStep(0, "", "1");
            }
          })
          .catch((e) => {
            if (e.response && e.response.data.code == "WB-401") {
              // EndSession
              isTimeOut.value = false;
              isSessionEnd.value = true;
            }
            page1Overlay.value = false;
          });
      }
    });
  } else {
    page1Overlay.value = false;
    jumpStep(0, "", "1");
  }
}
